module.exports = require("./be-tarask.d.ts");